var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sav-template',{attrs:{"title":"","back-button":false}},[(_vm.loading)?_c('sav-spinner',{attrs:{"size":10}}):_vm._e(),_vm._v(" "),(_vm.startStep)?_c('sav-timeline-form',{attrs:{"start":_vm.startStep}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c678356","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/companies/default/views/form/Home.vue
// module id = null
// module chunks = 